export default "__VITE_ASSET__DhQ0qFQE__"